import React, { useState } from 'react';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function ChangePassword() {
  const [form, setForm] = useState({
    current_password: '',
    new_password: '',
    confirm: '',
  });
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew]         = useState(false);
  const [loading, setLoading]         = useState(false);

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async () => {
    if (!form.current_password) return toast.error('Enter current password');
    if (!form.new_password)     return toast.error('Enter new password');
    if (form.new_password.length < 6) return toast.error('Password must be at least 6 characters');
    if (form.new_password !== form.confirm) return toast.error('Passwords do not match');
    if (form.current_password === form.new_password) return toast.error('New password must be different');

    setLoading(true);
    try {
      const r = await api.post('/auth/change-password', {
        current_password: form.current_password,
        new_password:     form.new_password,
      });
      toast.success(r.message || 'Password changed successfully!');
      setForm({ current_password: '', new_password: '', confirm: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed. Check current password.');
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">🔒 Change Password</h1>
        <p className="text-sm text-gray-500 mt-1">Update your login password</p>
      </div>

      <div className="card space-y-5">

        {/* Current Password */}
        <div>
          <label className="form-label">Current Password <span className="text-red-500">*</span></label>
          <div className="relative">
            <input type={showCurrent ? 'text' : 'password'} className="form-input pr-10"
              placeholder="Enter current password"
              value={form.current_password}
              onChange={e => f('current_password', e.target.value)} />
            <button type="button" onClick={() => setShowCurrent(p => !p)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
              {showCurrent ? '🙈' : '👁️'}
            </button>
          </div>
        </div>

        {/* New Password */}
        <div>
          <label className="form-label">New Password <span className="text-red-500">*</span></label>
          <div className="relative">
            <input type={showNew ? 'text' : 'password'} className="form-input pr-10"
              placeholder="Min 6 characters"
              value={form.new_password}
              onChange={e => f('new_password', e.target.value)} />
            <button type="button" onClick={() => setShowNew(p => !p)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
              {showNew ? '🙈' : '👁️'}
            </button>
          </div>
          {/* Strength indicator */}
          {form.new_password && (
            <div className="mt-2">
              <div className="flex gap-1 mb-1">
                {[1,2,3,4].map(i => (
                  <div key={i} className={`h-1 flex-1 rounded-full transition-all ${
                    form.new_password.length >= i * 3
                      ? i <= 1 ? 'bg-red-400'
                        : i <= 2 ? 'bg-yellow-400'
                        : i <= 3 ? 'bg-blue-400'
                        : 'bg-green-400'
                      : 'bg-gray-200'
                  }`} />
                ))}
              </div>
              <p className="text-xs text-gray-400">
                {form.new_password.length < 6 ? 'Too short' :
                 form.new_password.length < 8 ? 'Weak' :
                 form.new_password.length < 10 ? 'Medium' : 'Strong'}
              </p>
            </div>
          )}
        </div>

        {/* Confirm Password */}
        <div>
          <label className="form-label">Confirm New Password <span className="text-red-500">*</span></label>
          <input type="password" className="form-input"
            placeholder="Re-enter new password"
            value={form.confirm}
            onChange={e => f('confirm', e.target.value)} />
          {form.confirm && form.new_password !== form.confirm && (
            <p className="text-xs text-red-500 mt-1">Passwords do not match</p>
          )}
          {form.confirm && form.new_password === form.confirm && form.confirm.length >= 6 && (
            <p className="text-xs text-green-600 mt-1">✅ Passwords match</p>
          )}
        </div>

        <button onClick={handleSubmit}
          disabled={loading || !form.current_password || form.new_password !== form.confirm || form.new_password.length < 6}
          className="btn-primary w-full py-3 disabled:opacity-40">
          {loading ? '⏳ Updating...' : '🔒 Update Password'}
        </button>
      </div>
    </div>
  );
}